"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.BaseLogger = exports.LogLevel = void 0;
/* eslint-disable no-console */
const configs_1 = require("./configs");
const log_1 = require("./log");
const utils_1 = require("./utils");
var utils_2 = require("./utils");
Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function () { return utils_2.LogLevel; } });
const LOG_LEVELS = [
    utils_1.LogLevel.Debug,
    utils_1.LogLevel.Info,
    utils_1.LogLevel.Warn,
    utils_1.LogLevel.Error,
    utils_1.LogLevel.Critical,
];
const canLog = (tag, loglevel) => {
    return LOG_LEVELS.indexOf(tag) >= LOG_LEVELS.indexOf(loglevel);
};
// Todo: change to WebLogger
class BaseLogger {
    constructor(console, loglevel = utils_1.LogLevel.Debug, store, configs, callback) {
        var _a;
        this.console = console;
        this.loglevel = loglevel;
        this.store = store;
        this.callback = callback;
        this.disable = false;
        this.log = (loglevel, tag, tagConfigs, args) => {
            var _a, _b;
            const date = new Date();
            const time = this.formatTime(date);
            if (!this.disable && canLog(loglevel, this.loglevel)) {
                if (this.configs.withStyles) {
                    this.console.log(time, this.configs.showLevelLabel ? loglevel : " ", tag, tagConfigs, ...args);
                }
                else {
                    this.console.log(time, this.configs.showLevelLabel ? loglevel : " ", tag, tagConfigs, ...args);
                }
            }
            (_a = this.callback) === null || _a === void 0 ? void 0 : _a.call(this, time, loglevel, tag, ...args);
            (_b = this.store) === null || _b === void 0 ? void 0 : _b.save(date.getTime(), tag, loglevel, args).catch((error) => {
                // ignore log
            });
        };
        this.critical = (tag, ...args) => {
            this.log(utils_1.LogLevel.Critical, tag, this.configs.styles.Critical, args);
        };
        this.error = (tag, ...args) => {
            this.log(utils_1.LogLevel.Error, tag, this.configs.styles.Error, args);
        };
        this.warn = (tag, ...args) => {
            this.log(utils_1.LogLevel.Warn, tag, this.configs.styles.Warn, args);
        };
        this.info = (tag, ...args) => {
            this.log(utils_1.LogLevel.Info, tag, this.configs.styles.Info, args);
        };
        this.debug = (tag, ...args) => {
            this.log(utils_1.LogLevel.Debug, tag, this.configs.styles.Debug, args);
        };
        this.report = () => {
            var _a;
            return (_a = this.store) === null || _a === void 0 ? void 0 : _a.report();
        };
        this.clean = () => {
            var _a;
            return (_a = this.store) === null || _a === void 0 ? void 0 : _a.clean();
        };
        this.loglevel = loglevel;
        this.configs = (0, utils_1.trueAssign)(configs_1.DefaultConfigs, configs);
        log_1.debugMode.value = this.configs.debug;
        (0, log_1.debug)("gol new", loglevel, configs);
        if (this.configs.store !== "none") {
            (_a = this.store) === null || _a === void 0 ? void 0 : _a.init().catch((error) => {
                (0, log_1.debug)("store init failed", error);
            });
        }
    }
    formatTime(date) {
        return this.configs.showTime ? (0, utils_1.formatTime)(date) : "";
    }
    getLogger(tag) {
        var _a;
        return new Logger(tag, (_a = BaseLogger.instance) !== null && _a !== void 0 ? _a : this);
    }
    changeLevel(level) {
        this.loglevel = level;
    }
}
exports.BaseLogger = BaseLogger;
class Logger {
    constructor(tag, gol) {
        this.tag = tag;
        this.gol = gol;
        this.critical = (...args) => {
            this.gol.critical(this.tag, ...args);
        };
        this.error = (...args) => {
            this.gol.error(this.tag, ...args);
        };
        this.warn = (...args) => {
            this.gol.warn(this.tag, ...args);
        };
        this.info = (...args) => {
            this.gol.info(this.tag, ...args);
        };
        this.debug = (...args) => {
            this.gol.debug(this.tag, ...args);
        };
    }
}
exports.Logger = Logger;
